/**
 * SheetJS-free spreadsheet primitives. `secureXlsx.ts` re-exports them, but exports built on
 * exceljs import from here so the dashboard route does not pull the `vendor-spreadsheet` chunk
 * until a workbook is actually read.
 */
export const XLSX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** Prefixes a formula-leading cell with `'` so a viewer never evaluates it. */
export const sanitizeSpreadsheetCellValue = (value: string): string => {
  let cursor = 0;
  while (cursor < value.length) {
    const codePoint = value.codePointAt(cursor);
    if (codePoint == null || (codePoint > 0x20 && codePoint !== 0xfeff)) break;
    cursor += 1;
  }
  return cursor < value.length && '=+-@'.includes(value[cursor])
    ? `'${value}`
    : value;
};
